import { createStore, createTypedHooks, useStoreRehydrated } from 'easy-peasy'
import { storeModel } from './models/index'

const { useStoreDispatch, useStoreActions, useStoreState } = createTypedHooks()
export { useStoreActions, useStoreDispatch, useStoreState, useStoreRehydrated }

const store = createStore(storeModel, {name: 'nbtc-qos' })

export default store
